import { render, staticRenderFns } from "./ComboboxEixo.vue?vue&type=template&id=447d2a07&scoped=true"
import script from "./ComboboxEixo.vue?vue&type=script&lang=js"
export * from "./ComboboxEixo.vue?vue&type=script&lang=js"
import style0 from "./ComboboxEixo.vue?vue&type=style&index=0&id=447d2a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d2a07",
  null
  
)

export default component.exports